import * as types from "../../constants/action-types";

export function setSurveyStatus(payload) {
    return{type: types.SET_SURVEY_STATUS, payload};
}

export function requestStarted() {
    return {type : types.SET_REQUEST_STARTED};
}

export function requestEnded() {
    return {type : types.SET_REQUEST_ENDED};
}

export function setLoginFormName(payload) {
    return {type : types.SET_LOGIN_FORM_NAME, payload};
}

export const addPopup = (payload) => {
    return {type : types.SET_CURRENT_POPUP, payload};
}

export const removePopup = (payload) => {
    return {type : types.REMOVE_CURRENT_POPUP, payload};
}

export function setDeviceState(payload) {
    return {type : types.SET_DEVICE_STATE, payload};
}

export function setIsUpdatedConsents(payload) {
    return {type: types.SET_IS_UPDATED_CONSENTS, payload};
}

export const setBurgerState = (payload) => {
    return {type : types.SET_BURGER_STATE, payload};
}


export function setInitialRequestsDone() {
    return {type: types.SET_INITIAL_REQUESTS_DONE};
}



export function dismissMobileAppBanner() {
    return {type: types.SET_MOBILE_APP_BANNER};
}

export function setSearchFilters(payload) {
    return {type: types.SET_SEARCH_FILTERS, payload};
}

export function setBenefitsMapMode(payload) {
    return {type: types.SET_BENEFITS_MAP_MODE, payload};
}

export function setBenefitsPageNum(payload) {
    return {type: types.SET_BENEFITS_PAGE_NUM, payload};
}

export function setSearchState(payload){
    return{type: types.SET_SEARCH_STATE, payload};
}

export function setBenefitsStatus(payload) {
    return{type:types.SET_BENEFITS_STATUS, payload};
}
export function setUserRequestDone(payload){
    return{type:types.SET_USER_REQUEST_DONE, payload}
}
export function setMegaMenuId(payload){
    return{type:types.SET_MEGA_MENU_ID, payload}
}
export function setDrawerSubMenu(payload){
    return{type:types.SET_DRAWER_SUB_MENU, payload}
}

//Search Benefits Page

export function setDiscountDebitSearchFilters(payload){
    return {type: types.SET_DISCOUNT_DEBIT_SEARCH_FILTERS,payload};
}
export function setSelectedFilters(payload){
    return {type: types.SET_SELECTED_FILTERS, payload};
}

export function setFilteredDiscountDebitBenefits(payload){
    return {type: types.SET_FILTERED_DISCOUNT_DEBIT_BENEFITS,payload}
}



